module.exports = __webpack_public_path__ + "media/assets/images/flags/tv-becc45e0839921071c08c8fa5b729bd4.svg";